import { render, staticRenderFns } from "./HeaderPrincipal.vue?vue&type=template&id=c52b3d96&scoped=true"
import script from "./HeaderPrincipal.vue?vue&type=script&lang=ts"
export * from "./HeaderPrincipal.vue?vue&type=script&lang=ts"
import style0 from "./HeaderPrincipal.vue?vue&type=style&index=0&id=c52b3d96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52b3d96",
  null
  
)

export default component.exports